///<reference path="../../definitions/weather.d.ts"/>
///<reference path="../util/SDTDate.ts"/>
///<reference path="../Const.ts"/>

namespace app.model{
	import SDTDate = app.util.SDTDate;
	export class Weekly{
		data:WeeklyData;

		public parseData(json:any, location:string){
			let createDate = new SDTDate(json["announced"], Const.DATE_WEEKLY_CREATION);

			let data:WeeklyJSON = json[location],
				items:WeeklyDataItem[] = [];

			if(data){
				for(let i = 0; i < data.day.length; i++){
					items.push({
						date:new SDTDate(data.day[i], Const.DATE_WEEKLY),
						weather:data.telop[i],
						tmin:data.tmin[i],
						tmax:data.tmax[i],
						pop:data.pop[i]
					});
				}
				this.data = {
					createDate:createDate,
					name:data.name,
					items:items
				}
			}
		}
	}
}